import { apiMindbox, MINDBOX_OPERATIONS } from '@/fo/api/mindbox';
import type { ResponseError, ResponseSuccess } from '@/fo/api/mindbox';

const getLoyaltyLevel = async ({
  email,
  ids
}: {
  email: string | null;
  ids: { websiteID: string };
}): Promise<
  | ResponseSuccess<typeof MINDBOX_OPERATIONS.GET_CUSTOMER_LOYALTY_LEVEL>
  | ResponseError
  | null
> => {
  if (!ids?.websiteID) {
    const empty: ResponseSuccess<
      typeof MINDBOX_OPERATIONS.GET_CUSTOMER_LOYALTY_LEVEL
    > = {
      status: 'Success',
      balances: [],
      customerSegmentations: [
        {
          segmentation: {
            ids: {
              externalId: ''
            },
            name: ''
          },
          segment: {
            ids: {
              externalId: ''
            },
            name: ''
          }
        }
      ]
    };
    return empty;
  }
  return await apiMindbox(MINDBOX_OPERATIONS.GET_CUSTOMER_LOYALTY_LEVEL, {
    customer: {
      ...(email && { email }),
      ids: {
        websiteID: ids.websiteID
      }
    }
  });
};

const getCustomerInfo = async ({
  email,
  ids
}: {
  email: string | null;
  ids: { websiteID: string };
}): Promise<
  | ResponseSuccess<typeof MINDBOX_OPERATIONS.GET_CUSTOMER_INFO>
  | ResponseError
  | null
> => {
  if (!ids?.websiteID) {
    const empty: ResponseSuccess<typeof MINDBOX_OPERATIONS.GET_CUSTOMER_INFO> =
      {
        status: 'Success',
        balances: [],
        customer: { customFields: { loyaltyLevel: '' } },
        retailOrderStatistics: { totalPaidAmount: 0 }
      };
    return empty;
  }
  return await apiMindbox(MINDBOX_OPERATIONS.GET_CUSTOMER_INFO, {
    customer: {
      ...(email && { email }),
      ids: {
        websiteID: ids.websiteID
      }
    }
  });
};

const getCustomerBalanceHistory = async ({
  email,
  ids
}: {
  email: string | null;
  ids: { websiteID: string };
}): Promise<
  | ResponseSuccess<typeof MINDBOX_OPERATIONS.GET_CUSTOMER_BALANCE_HISTORY>
  | ResponseError
  | null
> => {
  if (!ids?.websiteID) {
    const empty: ResponseSuccess<
      typeof MINDBOX_OPERATIONS.GET_CUSTOMER_BALANCE_HISTORY
    > = {
      status: 'Success',
      customerActions: []
    };
    return empty;
  }
  return await apiMindbox(MINDBOX_OPERATIONS.GET_CUSTOMER_BALANCE_HISTORY, {
    customer: {
      ...(email && { email }),
      ids: {
        websiteID: ids.websiteID
      }
    },
    page: {
      itemsPerPage: 100,
      pageNumber: 1
    }
  });
};

export const loyaltyMindboxService = {
  getLoyaltyLevel,
  getCustomerInfo,
  getCustomerBalanceHistory
};
